<template>
  <div class="background">
    <div class="title">{{ info.worlds || msg }}</div>
    <div class="full" style="color: rgb(108,108,107);">{{ "银:" + info.silver }}</div>
    <div class="gy" style="color: rgb(222,146,4);"> {{ "金:" + info.coin }}</div>

    <div class="name">
      <!--      <span style="font-size: 1.5rem">{{info.name}}</span>-->
      <span style="color: rgb(4,134,182);">{{ "E:" + info.exp }}</span>
      <span style="color: rgb(232,120,7);">{{ "S:" + info.capacity }}</span>
      <span style="color: rgb(246,29,6);">{{ "L:" + info.level }}</span>
    </div>

    <div class="exp c1">专业：{{ info.professional }}</div>
    <div class="exp c2">健康：{{ info.healthy }}</div>
    <div class="exp c3">社交：{{ info.social }}</div>
    <div class="exp c4">形象：{{ info.images }}</div>
    <div class="exp c5">管理：{{ info.manage }}</div>

    <div class="index" @click="time()">回到Time</div>
    <div class="pk">开始 PK</div>
  </div>
</template>
<script>
export default {
  name: 'Gift',
  components: {},
  data() {
    return {
      msg: "天心阁",
      baseUrl: "http://goc6.com",
          //'http://localhost:8077',
      info: {}
    }
  },
  mounted() {
    this.getWorld();
  },
  methods: {
    getWorld() {
      const url = this.baseUrl + "/material/front/detail";
      let that = this;
      this.$axios.get(url, {
        player: localStorage.getItem("player")
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function (response) {
        that.info = response.data;
        console.log(response.data)
      })
    },
    time() {
      window.location.href = "/time";
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html, body {
  height: 100%;
  width: 100%;
  Font-size: 25%
}

.background {
  background-image: url("https://tu.ltyuanfang.cn/api/fengjing.php");
  height: 100%;
  width: 100%;
  position: absolute;
  background-size: cover;
  background-position: center;
}

.title {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 80%;
  top: 16%;
  left: 10%;
  color: rgb(61, 50, 39);
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
}

.full {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 20%;
  top: 12%;
  left: 50%;
  color: rgb(61, 50, 39);
  font-size: 0.6rem;
  font-weight: bold;
  text-align: center;
}

.gy {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 20%;
  top: 12%;
  left: 70%;
  color: rgb(61, 50, 39);
  font-size: 0.6rem;
  font-weight: bold;
  text-align: center;
}

.name {
  opacity: 0.8;
  border-radius: 10px 0;
  background: #FFF;
  position: absolute;
  width: 80%;
  top: 30%;
  left: 10%;
  color: rgb(61, 50, 39);
  font-weight: bold;
  text-align: center;
}

.exp {
  opacity: 0.8;
  border-radius: 10px 10px;
  background: #FFF;
  position: absolute;
  width: 50%;
  left: 25%;
  color: rgb(61, 50, 39);
  font-weight: bold;
  text-align: center;
}

.c1 {
  top: 60%;
}

.c2 {
  top: 65%;
}

.c3 {
  top: 70%;
}

.c4 {
  top: 75%;
}

.c5 {
  top: 80%;
}

.index {
  opacity: 0.8;
  border-radius: 5px 5px;
  background: #FFF;
  position: absolute;
  width: 30%;
  top: 90%;
  left: 15%;
  color: rgb(61, 50, 39);
  font-weight: bold;
  text-align: center;
}

.pk {
  opacity: 0.8;
  border-radius: 5px 5px;
  background: #FFF;
  position: absolute;
  width: 30%;
  top: 90%;
  left: 55%;
  color: rgb(61, 50, 39);
  font-weight: bold;
  text-align: center;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/game/Gift.vue